<div mat-dialog-title><h2>GRACIAS</h2></div>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>